<template>
  <NuxtLayout name="default">
    <PagesBlogPage><slot></slot></PagesBlogPage>
  </NuxtLayout>
</template>
